export default __webpack_public_path__ + "static/media/back.0b2b4933.png";